export default "__VITE_ASSET__C$yIPQMM__"